import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  InputLabel,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { verifyNullValue } from '@auteco/utils/verifyNullValue'
import {
  getEvents,
  postEvent,
  postMonthEvent,
  putEvent,
  editMonthEvent,
  postMonthEventNoGroup,
} from '@auteco/services/snopServices'
import { AlertAddEvent } from '../AlertAddEvent'
import { useStyles } from './styles'

const initialForm = {
  descripcion: '',
  tipo_id: 0,
  responsable_id: null,
}

const generateMonthsArray = () => {
  const months = []
  const currentDate = new Date()
  
  for (let i = 0; i < 16; i += 1) {
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1)
    const year = date.getFullYear().toString().slice(-2)
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    
    months.push({
      ejecucion: `${year}-${month}`,
      displayDate: `1/${month}/${year}`,
      incremento: '',
      decrecimiento: '',
    })
  }
  
  return months
}

export const DialogAddEvent = ({
  users,
  groupId,
  edit,
  item,
  material,
  onGetEvents,
  open,
  onClose,
  getconsolidadoInfo,
  filter,
}) => {
  const [form, setForm] = useState(initialForm)
  const [idEvent, setIdEvent] = useState(null)
  const [openAlert, setOpenAlert] = useState(false)
  const [section, setSection] = useState('description')
  const [months, setMonths] = useState(generateMonthsArray())
  const classes = useStyles()

  const resetValues = () => {
    setForm(initialForm)
    setSection('description')
    setMonths(generateMonthsArray())
    setIdEvent(null)
  }

  const handleClose = () => {
    resetValues()
    onClose()
  }

  const updateForm = ({ param, value }) => {
    setForm(prevForm => ({ ...prevForm, [param]: value }))
  }

  const onCreateEvent = async () => {
    const body = { ...form, grupo_id: groupId }
    const response = await postEvent({ params: body })

    if (response.error) {
      alert(response.error)
      return
    }

    await getconsolidadoInfo()
    
    if (response.id) {
      setIdEvent(response.id)
      setSection('months')
      if (groupId !== 0) {
        getEvents({ id: groupId })
      }
    }
  }

  const updateInfoEvent = async () => {
    const formatedMonths = months.map((month) => ({
      ejecucion: month.ejecucion,
      cantidad: month.incremento ? month.incremento : month.decrecimiento,
      evento_id: form.id,
    }))
    const body = { ...form, id: item.id, meses: formatedMonths }
    const { success } = await putEvent({ params: body })
    await getconsolidadoInfo()

    if (success) {
      return true
    }

    return false
  }

  const updateEvent = async () => {

    const succesData = await updateInfoEvent()

    if (!succesData) {
      alert('Error al actualizar la información del evento')
      return
    }

    const eventos = months
      .map(month => {
        let cantidad = 0
        if (month.incremento) {
          cantidad = parseFloat(month.incremento)
        } else if (month.decrecimiento) {
          cantidad = -parseFloat(month.decrecimiento)
        }
        
        if (cantidad === 0) return null

        return {
          evento_id: item.id,
          material: item.material,
          ejecucion: `${month.ejecucion}-01`,
          cantidad
        }
      })
      .filter(Boolean)

    if (!eventos.length) {
      alert('No hay cambios para guardar')
      resetValues()
      onClose()
      return
    }

    try {
      const { error } = await editMonthEvent({ params: { eventos } })
      
      if (error) {
        console.log(error)
      }

      await getconsolidadoInfo()
      onGetEvents()
      resetValues()
      onClose()
      alert('Cambios guardados con éxito')
    } catch (error) {
      alert('Error al guardar los cambios')
      resetValues()
      onClose()
    }
  }

  const onChangeMonth = ({ index, param, value }) => {
    const newMonths = [...months]
    newMonths[index] = { 
      ...newMonths[index], 
      [param]: value > 0 ? value : '' 
    }
    setMonths(newMonths)
  }

  const isParamEmpty = () => Object.entries(form)
      .filter(([, value]) => value === null || value === '')
      .map(([key]) => key)

  const saveAllMonths = async () => {
    const monthsToSave = months.filter(
      month => month.incremento || month.decrecimiento
    )

    if (!monthsToSave.length) {
      alert('No hay cambios para guardar')
      resetValues()
      onClose()
      return
    }

    try {
      await Promise.all(monthsToSave.map(async month => {
        const cantidad = month.incremento ? month.incremento : -month.decrecimiento
        const body = {
          evento_id: idEvent,
          ejecucion: `${month.ejecucion}-01`,
          cantidad,
          ...(filter ? { filtros: filter } : { material: material || 0 })
        }

        const { error } = filter
          ? await postMonthEventNoGroup({ params: body })
          : await postMonthEvent({ params: body })

        if (error) {
          throw new Error(`Error al guardar el mes ${month.ejecucion}: ${error}`)
        }
      }))

      await getconsolidadoInfo()
      onGetEvents({ id: groupId })
      resetValues()
      onClose()
      alert('Cambios guardados con éxito')
    } catch (error) {
      alert(error.message)
      resetValues()
      onClose()
    }
  }

  useEffect(() => {
    if (item && edit) {
      setForm({
        descripcion: item.descripcion,
        responsable_id: item.responsable_id,
        tipo_id: item.tipo_id,
        id: item.id
      })

      if (!item.meses?.length) {
        setMonths(generateMonthsArray())
        setIdEvent(item.id)
        return
      }

      const baseMonths = generateMonthsArray()
      const updatedMonths = baseMonths.map(baseMonth => {
        const existingMonth = item.meses.find(m => {
          const [year, month] = m.ejecucion.split('-')
          return `${year.slice(-2)}-${month}` === baseMonth.ejecucion
        })

        if (!existingMonth) return baseMonth

        const cantidad = parseFloat(existingMonth.cantidad)
        return {
          ...baseMonth,
          incremento: cantidad > 0 ? cantidad.toString() : '',
          decrecimiento: cantidad < 0 ? Math.abs(cantidad).toString() : '',
        }
      })

      setMonths(updatedMonths)
      setIdEvent(item.id)
    } else {
      resetValues()
    }
  }, [item, edit, open])

  return (
    <>
      <AlertAddEvent open={openAlert} onClose={() => setOpenAlert(false)} />
      <Dialog open={open} onClose={handleClose}>
        <DialogContent className={classes.dialogContent}>
          {section === 'description' && (
            <>
              <DialogTitle className={classes.dialogTitle}>
                {edit ? 'Editar evento' : 'Crear evento'}
              </DialogTitle>
              {item?.material && (
                <Typography className={classes.materialTitle}>
                  Evento del material: {item.material}
                </Typography>
              )}
              <TextField
                value={form.descripcion}
                label="Descripción"
                variant="outlined"
                onChange={e => updateForm({ 
                  param: 'descripcion', 
                  value: e.target.value 
                })}
              />
              <Autocomplete
                placeholder="Responsable"
                value={users.find(option => option.id === form.responsable_id) || null}
                options={users}
                className={classes.textField}
                getOptionLabel={option => `${option.nombre} ${option.apellido}`}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Responsable"
                    variant="outlined"
                  />
                )}
                onChange={(e, newValue) => updateForm({
                  param: 'responsable_id',
                  value: verifyNullValue({ value: newValue, param: 'id' }),
                })}
              />
              <InputLabel htmlFor="tipo" className={classes.inputLabel}>
                Tipo de evento
              </InputLabel>
              <Grid
                component="label"
                container
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <Grid item>
                  <Typography className={form.tipo_id === 0 && classes.typeSelected}>
                    Planeación futura
                  </Typography>
                </Grid>
                <Grid item>
                  <Switch
                    checked={form?.tipo_id === 1}
                    className={classes.switch}
                    onChange={(e, checked) =>
                      updateForm({ param: 'tipo_id', value: checked ? 1 : 0 })
                    }
                  />
                </Grid>
                <Grid item>
                  <Typography className={form.tipo_id === 1 && classes.typeSelected}>
                    Contingencia
                  </Typography>
                </Grid>
              </Grid>
              {filter && (
                <p>⚠️ Este evento se creará para todos los materiales seleccionados en el filtro</p>
              )}
              <Button
                style={{ display: edit ? 'none' : 'block' }}
                className={classes.actionBtn}
                variant="contained"
                disabled={isParamEmpty().length > 0}
                onClick={edit ? updateEvent : onCreateEvent}
              >
                {edit ? 'Editar' : 'Crear'}
              </Button>
            </>
          )}
          {(section === 'months' || edit) && (
            <>
              <DialogTitle className={classes.dialogTitle}>
                {edit ? 'Editar mes y cantidad' : 'Añadir mes y cantidad'}
              </DialogTitle>
              {!edit && (
                <Typography>
                  <span className={classes.eventSubtitle}>Evento: </span>
                  {form?.descripcion}
                </Typography>
              )}
              <div className={classes.monthsMainContainer}>
                <Grid container spacing={2}>
                  {months.map((month, index) => (
                    <Grid item xs={12} key={month.ejecucion}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                          <Typography variant="body1">{month.displayDate}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            label="Incremento"
                            variant="outlined"
                            type="number"
                            fullWidth
                            value={month.incremento}
                            disabled={!!month.decrecimiento}
                            className={classes.amountGreen}
                            onChange={e => onChangeMonth({
                              index,
                              param: 'incremento',
                              value: e.target.value
                            })}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            label="Decrecimiento"
                            variant="outlined"
                            type="number"
                            fullWidth
                            value={month.decrecimiento}
                            disabled={!!month.incremento}
                            className={classes.amountRed}
                            onChange={e => onChangeMonth({
                              index,
                              param: 'decrecimiento',
                              value: e.target.value
                            })}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </div>
              <Button
                className={classes.actionBtn}
                variant="contained"
                color="primary"
                fullWidth
                onClick={edit ? updateEvent : saveAllMonths}
                disabled={!months.some(month => month.incremento || month.decrecimiento)}
              >
                GUARDAR CAMBIOS
              </Button>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default DialogAddEvent
